import React, { useState, useEffect } from 'react';
import { List, ListItem, ListItemIcon, ListItemText, Divider, IconButton, Box, Tooltip, Typography, Drawer, AppBar, Toolbar } from '@mui/material';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import logo from '../../Images/autosdlcblack.png';
import { IconGitPullRequest, IconFileInvoice, IconHeadset, IconHome, IconMenu2, IconReceiptDollar } from '@tabler/icons-react';
import { useMediaQuery } from '@mui/material';
import userprofile from '../../Images/user-1.jpg';
import { useTheme } from '@emotion/react';

const Sidebar = () => {
    const location = useLocation();
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const userInfo = JSON.parse(sessionStorage.getItem('user-info'));
    const navigate = useNavigate();
    const isMobile = useMediaQuery('(max-width: 1200px)');

    const allMenuItems = [
        { text: 'My Projects', icon: <IconHome />, paths: ['/Dashboard', '/managerinput', '/newproject', '/projectview', '/masterScopeview', '/addstakeholder'], roles: ['is_admin', 'is_manager', 'is_stakeholder'] },
        { text: 'Requests', icon: <IconGitPullRequest />, paths: ['/requests'], roles: ['is_admin', 'is_manager', 'is_stakeholder'] },
        { text: 'Documents', icon: <IconFileInvoice />, paths: ['/documents', '/generatedfiles', '/generateddocs'], roles: ['is_admin', 'is_manager', 'is_stakeholder'] },
        { text: 'Plans', icon: <IconReceiptDollar />, paths: ['/plans'], roles: ['is_admin'] },
        { text: 'Help & Support', icon: <IconHeadset />, paths: ['/help-support'], roles: ['is_admin'] },
    ];

    const menuItems = allMenuItems.filter((item) =>
        item.roles.some((role) => userInfo[role])
    );

    const handleToggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    useEffect(() => {
        setIsSidebarOpen(!isMobile);
    }, [isMobile]);
    const theme = useTheme();

    return (
        <>
            {/* Mobile Toggle Button */}
            {/* {isMobile && !isSidebarOpen && (
                <IconButton
                    onClick={handleToggleSidebar}
                    sx={{
                        position: 'fixed',
                        top: 29,
                        left: 15,
                        zIndex: 2000,
                        color: '#602aa3',
                    }}
                >
                    <IconMenu2 size={35} />
                </IconButton>
            )} */}
            {isMobile && !isSidebarOpen && (
                    <AppBar position="fixed" sx={{ backgroundColor: "#fff", zIndex: theme.zIndex.drawer + 1,boxShadow:2,height:"60px"}}>
                    <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
                        <img src={logo} alt="Logo" style={{ height: "40px" }} />
                        <IconButton onClick={handleToggleSidebar} sx={{ color: "#000" }}>
                        <IconMenu2 />
                        </IconButton>
                    </Toolbar>
                    </AppBar>
                )}
            {/* Sidebar */}
            <Drawer
                variant={isMobile ? 'temporary' : 'permanent'}
                open={isSidebarOpen}
                onClose={handleToggleSidebar}
                sx={{
                    '& .MuiDrawer-paper': {
                        width: isSidebarOpen ? '300px' : '90px',
                        background: 'linear-gradient(to bottom, #072a69, #082c7c, #152d8e, #272c9f, #3b29af)',
                        height: '100vh',
                        // padding: isSidebarOpen ? '7px' : '10px',
                        border: !isMobile ? '15px solid #fff' : "",
                        borderRadius: isMobile ? '0px' : '30px ',
                        overflow: 'hidden',
                        transition: 'width 0.3s ease-in-out',
                        position: 'relative',
                    },
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background:isSidebarOpen ? '#f6f7fb' : "none",padding:isSidebarOpen ? '2px' : '10px',borderRadius:isMobile ? '0px' : '15px 15px 0px 0px',border:isSidebarOpen?"1px solid #f6f7fb":"none      " ,boxShadow:3}}>
                    {isSidebarOpen && (
                        <img
                            src={logo}
                            alt="Logo"
                            style={{ width: '80%', transition: 'opacity 0.3s', opacity: isSidebarOpen ? 1 : 0 }}
                            onClick={() => navigate('/Dashboard')}
                        />
                    )}
                    <IconButton onClick={handleToggleSidebar} sx={{ color:isSidebarOpen ? '#000' : "#fff" }}>
                        <IconMenu2 />
                    </IconButton>
                </Box>

                <Divider />
                <div style={{ flex: 1, overflowY: 'auto', scrollbarWidth: 'none', msOverflowStyle: 'none', padding: isSidebarOpen ? '10px' : '10px' }}>
                    <List>
                        {menuItems.map((item, index) => {
                            const isActive = item.paths.some(path => location.pathname.includes(path));
                            return (
                                <ListItem
                                    button
                                    key={index}
                                    component={Link}
                                    to={item.paths[0]}
                                    sx={{
                                        backgroundColor: isActive ? '#fff' : 'transparent',
                                        borderRadius: '5px',
                                        margin: '5px 0',
                                        '&:hover': { backgroundColor: isActive ? '#fff' : '#8c93e5' },
                                        justifyContent: isSidebarOpen ? 'flex-start' : 'center',
                                    }}
                                >
                                    <Tooltip title={item.text} placement="right" disableHoverListener={isSidebarOpen} arrow>
                                        <ListItemIcon sx={{ color: isActive ? '#7a5af9' : '#fff', minWidth: isSidebarOpen ? '35px' : 'auto' }}>
                                            {item.icon}
                                        </ListItemIcon>
                                    </Tooltip>
                                    {isSidebarOpen && (
                                        <ListItemText sx={{ color: isActive ? '#7a5af9' : '#fff' }}>
                                            {item.text}
                                        </ListItemText>
                                    )}
                                </ListItem>
                            );
                        })}
                    </List>
                </div>

                {/* User Profile Section */}
                <Box
                    sx={{
                        padding: isSidebarOpen ? "10px" : "5px",
                        background: "#fff",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        cursor: "pointer",
                        margin: '10px', // Add margin to separate from edges
                    }}
                    onClick={() => navigate('/myprofile')}
                >
                    <Box>
                        <img
                            src={userprofile}
                            alt="User Profile"
                            style={{
                                width: "40px",
                                height: "40px",
                                transition: "opacity 0.3s",
                                borderRadius: "50%",
                                margin: "auto",
                                display: "block",
                            }}
                        />
                    </Box>
                    {isSidebarOpen && (
                        <Box sx={{ textAlign: "left", color: "#fff" }}>
                            <Typography variant="body1" fontWeight="bold" color='#4227b4'>{userInfo.fullname}</Typography>
                            <Tooltip title={userInfo.email} arrow>
                                <Typography variant="body2" fontWeight="bold" color='#4227b4' sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "150px", cursor: "pointer" }}>
                                    {userInfo.email.length > 18 ? `${userInfo.email.slice(0, 18)}...` : userInfo.email}
                                </Typography>
                            </Tooltip>
                        </Box>
                    )}
                </Box>

                {/* Hide scrollbar */}
                <style>
                    {`
                    div::-webkit-scrollbar {
                        display: none;
                    }
                `}
                </style>
            </Drawer>
        </>
    );
};

export default Sidebar;
